import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube, FaWhatsapp, FaTelegramPlane } from "react-icons/fa";
import "./Social_Icons.css";

const UpdatedSocialIcons = () => {
  return (
    <div className="updated-social-icons">
      <ul>
        <li><a href="https://www.facebook.com/people/Sri-Takshashila-Gurukul/pfbid02DjT1cUvi6JXFkWvK1Sbh5DGD7piBrnxuVfxeDr9hSXUMP61NM6eS76CipJFSrQ5Wl/" className="fb-icon" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a></li>
        <li><a href="https://www.instagram.com/sritakshashila/" className="ig-icon" target="_blank" rel="noopener noreferrer"><FaInstagram /></a></li>
        <li><a href="https://www.linkedin.com/company/rcfindia/posts/?feedView=all" className="li-icon" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a></li>
        <li><a href="https://www.youtube.com/@SriTakshashilaGurukul" className="yt-icon" target="_blank" rel="noopener noreferrer"><FaYoutube /></a></li>
        <li><a href="https://www.whatsapp.com/channel/0029VaMRwERDuMRbNDXKsn2d" className="wa-icon" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a></li>
        <li><a href="https://t.me/SriTakshashilaGurukulhttps://www.linkedin.com/authwall?trk=bf&trkInfo=AQGzPCLRFss8kQAAAZQbPdKAag8C5hnqmG8vGsuKNHmpJWARit4rCe7UM0uNdFuC9ZGph6A0QE6ZXovZR3D-x36avNBUVRBp1scqy1HHutLEAaSp_TJkIS_a4zHpFoAadr7BY24=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fin%2Fsritakshashila-gurukul-385b41306%2F" className="tg-icon" target="_blank" rel="noopener noreferrer"><FaTelegramPlane /></a></li>
      </ul>
    </div>
  );
};

export default UpdatedSocialIcons;
